"use client";

import { TravelAgentLogo } from "components/layouts/Header/TravelAgentLogo";
const AppHeaderLeft = () => {
  return <TravelAgentLogo className='text-white' data-sentry-element="TravelAgentLogo" data-sentry-component="AppHeaderLeft" data-sentry-source-file="AppHeaderLeft.tsx" />;
};
export default AppHeaderLeft;